import { Switch } from '@/common/ui/switch'
import useMutationUpdateGeneralSetting from '@/modules/client-setting/api/hooks/useMutationUpdateGeneralSetting'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'
import { useState } from 'react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { GeneralSettingQueryKeys } from '@/modules/client-setting/keys'
import useHasPermission from '@/common/hooks/useHasPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface SendWithdrawLineFlexMessageProps {
	data: GetGeneralSettingResponse
}

export function SendWithdrawLineFlexMessage({
	data,
}: SendWithdrawLineFlexMessageProps) {
	const queryClient = useQueryClient()
	const [isLoading, setIsLoading] = useState(false)
	const { mutateAsync: updateGeneralSetting } =
		useMutationUpdateGeneralSetting()
	const hasWritePermission = useHasPermission(PermissionKeys.WEB_SETTING)

	const handleChange = async (value: boolean) => {
		if (!hasWritePermission) return

		setIsLoading(true)
		try {
			await updateGeneralSetting({
				payload: {
					sendWithdrawLineFlexMessage: value,
				},
			})
			toast.success('อัพเดทการตั้งค่าการแจ้งเตือนถอนเงินสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [GeneralSettingQueryKeys.GetGeneralSetting],
			})
		} catch (error) {
			showErrorToast(error as Error)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<Switch
			checked={data?.sendWithdrawLineFlexMessage ?? true}
			onCheckedChange={handleChange}
			disabled={isLoading || !hasWritePermission}
		/>
	)
}
